import { useLayoutEffect } from 'react';
import {
  SHARE_IMAGE_META_KEYS,
  buildEventShareMeta,
  eventHeadMeta,
  type EventShareSource,
} from '@/lib/event-open-graph';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  const selector = `meta[${attr}="${key}"]`;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

export function useEventOpenGraph(source: EventShareSource | null) {
  const title = source?.title ?? '';
  const description = source?.description ?? '';
  const image = source?.image ?? '';
  const slug = source?.slug ?? '';

  useLayoutEffect(() => {
    if (!title || !slug) return;

    const meta = buildEventShareMeta(
      { title, description, image, slug },
      window.location.origin,
      window.location.href.split('?')[0]
    );
    const previousTitle = document.title;
    document.title = meta.title;

    for (const tag of eventHeadMeta(meta)) {
      upsertMeta(tag.attr, tag.key, tag.content);
    }

    if (!meta.image) {
      for (const tag of SHARE_IMAGE_META_KEYS) {
        document.head.querySelector(`meta[${tag.attr}="${tag.key}"]`)?.remove();
      }
    }

    return () => {
      document.title = previousTitle;
    };
  }, [title, description, image, slug]);
}
